<template>
  <div
    class="event-result"
  >
    <div class="info">
      <EventStatusBall
        class="status"
        :status="event.statusType"
      />
      <span class="title">{{ name }}</span>
      <span class="category">{{ categoryName }}</span>
    </div>

    <div class="buttons">
      <RouterLink
        :to="editBaseInfoRoute"
      >
        <NorticIconButton
          v-tooltip="'Redigera basinfo'"
          slim
          theme-type="accent"
          icon="@icons/streamline-icons/Outline version/48-Maps-Navigation/10-Pins-Style One/style-one-pin-information.svg"
          @click="closeMenuAndClearOmniSearch"
        />
      </RouterLink>
      <RouterLink
        :to="editVenueRoute"
        @click="closeMenuAndClearOmniSearch"
      >
        <NorticIconButton
          v-tooltip="'Redigera spelplats'"
          slim
          theme-type="accent"
          icon="@icons/streamline-icons/Outline version/48-Maps-Navigation/02-Maps/maps-pin-1.svg"
          @click="closeMenuAndClearOmniSearch"
        />
      </RouterLink>
      <RouterLink
        :to="editPricingRoute"
        @click="closeMenuAndClearOmniSearch"
      >
        <NorticIconButton
          v-tooltip="'Redigera prissättning'"

          slim
          theme-type="accent"
          icon="@icons/streamline-icons/Outline version/09-Shopping-Ecommerce/06-Tags-Codes/tag-dollar.svg"
          @click="closeMenuAndClearOmniSearch"
        />
      </RouterLink>
      <a
        :href="bookingUrl"
        target="_blank"
        @click="closeMenuAndClearOmniSearch"
      >
        <NorticIconButton
          v-tooltip="'Gå till bokningssida'"
          slim
          theme-type="accent"
          icon="@icons/streamline-icons/Outline version/04-Programing-Apps-Websites/10-Apps/monitor-shopping-cart.svg"
        />
      </a>
    </div>
  </div>
</template>

<script>
import NorticIconButton from '@/components/common/button/nortic-button/NorticIconButton.vue';
import EventStatusBall from '@/components/common/status-ball/EventStatusBall.vue';
import subModuleKeys from '@/modules/constants/subModuleKeys';
import { mapGetters } from 'vuex';
import GetterTypes from '@/store/constants/getters';
import MutationTypes from '@/store/constants/mutations';

export default {
  name: 'OmniSearchEventResult',
  components: {
    EventStatusBall,
    NorticIconButton,
  },
  props: {
    event: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    ...mapGetters([
      GetterTypes.ORGANIZER_ID,
      GetterTypes.OMNI_SEARCH_EVENT_BUS,
    ]),
    name() {
      return this.event?.name;
    },
    categoryName() {
      return this.event?.eventCategoryView?.name;
    },
    editBaseInfoRoute() {
      return {
        name: subModuleKeys.MANAGE_EVENT_BASIC_INFO(subModuleKeys.MANAGE_EVENT),
        params: {
          eventId: this.event?.id,
        },
      };
    },
    editVenueRoute() {
      return {
        name: subModuleKeys.MANAGE_EVENT_VENUE(subModuleKeys.MANAGE_EVENT),
        params: {
          eventId: this.event?.id,
        },
      };
    },
    editPricingRoute() {
      return {
        name: subModuleKeys.MANAGE_EVENT_PRICING(subModuleKeys.MANAGE_EVENT),
        params: {
          eventId: this.event?.id,
        },
      };
    },
    bookingUrl() {
      return `${process.env.VUE_APP_STATIC_URL}dagny/event/${this.event.id}`;
    },
  },
  methods: {
    closeMenuAndClearOmniSearch() {
      this.omniSearchEventBus.emit('clear');
      this.$store.commit(MutationTypes.SET_SHOW_MENU, false);
    },
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style lang="scss" scoped>
  .event-result {
    &:hover {
      background-color: var(--input-hover-bg-hex);
    }

    transition: all 0.2s;
    background-color: var(--input-bg-hex);
    border-radius: 6px;
    padding: 0.8em;
    display: grid;
    grid-gap: 1em;
    box-shadow: 0 0 3px 2px rgba(var(--shadow-color-rgb), 0.12), 0 1px 2px rgba(var(--shadow-color-rgb), 0.24);

    .info {
      display: grid;
      grid-template-areas:
        "status title"
        ". category";
      grid-template-columns: min-content 1fr;
      align-items: center;
      grid-gap: 0.1em 0.8em;

      .status {
        grid-area: status;
      }

      .title {
        font-weight: 500;
        grid-area: title;
        word-break: break-all;
      }

      .category {
        grid-area: category;
        font-size: 0.8em;
      }
    }

    .buttons {
      display: grid;
      grid-auto-flow: column;
      grid-gap: 0.25em;
      justify-content: flex-start;
      font-size: 1em;
    }
  }
</style>
